import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { CultureMapItemModel } from '../../entities/culture-map-item.model';
import {
    DetailBooleanComponent,
    DetailContactComponent,
    DetailMapItemLinkComponent,
    DetailViewModule,
} from '@ui/shared/ui-detail-view';
import { CultureMapOfferingItemModel } from '../../entities/culture-map-offering-item.model';

@Component({
    selector: 'ui-culture-map-item-offering-detail',
    imports: [
        DetailMapItemLinkComponent,
        DetailViewModule,
        DetailContactComponent,
        DetailBooleanComponent,
    ],
    templateUrl: './culture-map-item-offering-detail.component.html',
    styleUrl: './culture-map-item-offering-detail.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CultureMapItemOfferingDetailComponent {
    public readonly mapItemTriggeredById = output<CultureMapItemModel>();

    public offering = input.required<CultureMapOfferingItemModel>();

    public cultureExperienceTypes = computed(() => this.offering().cultureExperienceTypes.map(type => type.label));
    public targetGroups = computed(() => this.offering().targetGroups.map(type => type.label));

    public triggerMapItemById(linkedItem: CultureMapItemModel): void {
        this.mapItemTriggeredById.emit(linkedItem);
    }
}
